export default "__VITE_ASSET__N3U3vM4f__"